import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import VizsgazoTableDto from '../dto/VizsgazoTableDto';

class VizsgazoTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgazoTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<VizsgazoTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, VizsgazoTableDto)))
				.catch(reject);
		});
	}
}

export default new VizsgazoTableService();
